import React from "react";
import { motion } from "framer-motion";

import styled from "styled-components";
import HomeSlider from "./HomeSlider";

// Animation Variants
const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const slideInRight = {
  hidden: { opacity: 0, x: 100 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const HomeOverview = () => {
  return (
    <Section>
      <Container className="container">
        <Row className="row align-items-center">
          <Col className="col-lg-6">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
              className="who-we-are__content"
            >
              <Title className="who-we-are__title">Overview</Title>
              <Subtitle className="mb-4">
                Accelerating Digital Transformation
              </Subtitle>
              <Paragraph className="who-we-are-paragraph">
                NexTech is a leading provider of PLM and Engineering solutions,
                specializing in Teamcenter PLM and CAD/CAM/CAE services. We help
                businesses worldwide accelerate digital transformation by
                integrating cutting-edge technology and tailored solutions. With
                deep expertise in PLM implementation, consulting, and
                engineering design, we optimize profitability and efficiency for
                our clients. NexTech delivers innovative, reliable, and
                cost-effective solutions through collaboration, technology
                expertise, and a customer-centric approach. Our agile team
                focuses on business excellence by aligning solutions with
                customer goals, ensuring rapid deployment, and maximizing ROI.
              </Paragraph>
            </motion.div>
          </Col>
          <Col className="col-lg-6">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={slideInRight}
              className="who-we-are__img"
            >
              <ImageContainer>
                <HomeSlider />
              </ImageContainer>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </Section>
  );
};

export default HomeOverview;

const Section = styled.section`
  padding: 20px 20px;
  margin-top: 40px;
`;

const Container = styled.div`
  width: 100%;

  margin: 0 auto;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 576px) {
    flex-direction: column;
  }
`;

const Col = styled.div`
  flex: 1;

  @media (max-width: 992px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

const Title = styled.h1`
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 3.1em;
  color: #06334b;
  margin-bottom: 30px;

  span {
    color: #07b6f2;
  }

  @media (max-width: 992px) {
    font-size: 2.5em;
  }

  @media (max-width: 768px) {
    font-size: 2.4em;
  }

  @media (max-width: 576px) {
    font-size: 1.89em;
    text-align: left;
  }
`;

const Subtitle = styled.h4`
  color: #06334b;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1.5em;
  margin-bottom: 2rem;

  @media (max-width: 992px) {
    font-size: 1.4em;
  }

  @media (max-width: 768px) {
    font-size: 1.3em;
  }

  @media (max-width: 576px) {
    font-size: 1em;
    text-align: left;
  }
`;

const Paragraph = styled.p`
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1em;
  line-height: 1.91;
  color: #777777;
  text-align: justify;

  @media (max-width: 992px) {
    font-size: 0.95em;
  }

  @media (max-width: 768px) {
    font-size: 0.9em;
  }

  @media (max-width: 576px) {
    font-size: 0.91em;
  }
`;

const ImageContainer = styled.div`
  height: fit-content;

  @media (max-width: 576px) {
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;
